import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// components
import { SignupComponent } from './epics/Account/signup/signup.component';
import { ConfirmemailComponent } from './epics/Account/confirmemail/confirmemail.component';
import { CreateWorkspaceComponent } from './epics/fusion/Pages/Workspace/create-workspace/create-workspace.component';
import { SelectWorkspaceComponent } from './epics/fusion/Pages/Workspace/select-workspace/select-workspace.component';
import { ActivationComponent } from './epics/Account/Activation/activation/activation.component';
//Services
import { AuthGuardService } from './core/services/auth/auth-guard.service';
import { ResetpasswordComponent } from './epics/Account/ResetPassword/resetpassword/resetpassword.component';
import { CreatepasswordComponent } from './epics/Account/createPassword/createpassword/createpassword.component';
import { ApisDashboardComponent } from './epics/fusion/Pages/dashboard-journey/apis-dashboard.component';
import { MobileTopUpComponent } from './epics/fusion/Pages/dashboard-journey/mobile-top-up/mobile-top-up.component';
import { UtilityBillComponent } from './epics/fusion/Pages/dashboard-journey/utility-bill/utility-bill.component';
import { LoginDashboardComponent } from './epics/fusion/Pages/dashboard-journey/login-dashboard/login-dashboard.component';
import { OverviewDashboardComponent } from './epics/fusion/Pages/dashboard-journey/overview-dashboard/overview-dashboard.component';
import { PayAnyoneDashboardComponent } from './epics/fusion/Pages/dashboard-journey/pay-anyone-dashboard/pay-anyone-dashboard.component';
import { ProgressiveInsightsDashboardComponent } from './epics/fusion/Pages/dashboard-journey/progressive-insights-dashboard/progressive-insights-dashboard.component';
import { RouteGaurdGuard } from './core/services/route-gaurd/route-gaurd.guard';
import { OnboardingGuard } from './core/services/auth/onboarding.guard';
import { NotFoundComponent } from './shared/shared-components/not-found/not-found.component';
import { NEW_ONBOARDING_REDIRECT_ROUTES } from './core/services/shared-session/new-onboarding-redirect';

const appRoutes: Routes = [
    // When environment.newOnboarding.enabled, /account/* and /get-started/* go to the new
    // onboarding app instead of the pages below (see new-onboarding-redirect.ts).
    ...NEW_ONBOARDING_REDIRECT_ROUTES,
    {
        path: 'account',
        title: 'Fusion - Authentication',
        // canActivate: [AuthGuardService],
        loadChildren: () =>
            import('./epics/Authentication/Authentication.module').then(
                (m) => m.AuthenticationModule
            ),
    },
    {
        path: 'get-started',
        title: 'Fusion - Get Started',
        // canActivate: [AuthGuardService],
        loadChildren: () =>
            import('./epics/get-started/get-started.module').then(
                (m) => m.GetStartedModule
            ),
    },
    {
        path: 'account/signup',
        component: SignupComponent,
    },
    {
        path: 'account/confirm_email',
        component: ConfirmemailComponent,
    },
    {
        path: 'account/resetpassword',
        component: ResetpasswordComponent,
    },
    {
        path: 'account/createpassword',
        component: CreatepasswordComponent,
    },
    {
        path: 'workspace/create-workspace',
        component: CreateWorkspaceComponent,
        canActivate: [AuthGuardService],
    },

    {
        path: 'workspace/select-workspace',
        canActivate: [AuthGuardService],
        component: SelectWorkspaceComponent,
    },
    {
        path: 'account/activation',
        component: ActivationComponent,
    },

    {
        path: 'apidashboard',
        component: ApisDashboardComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Apis Dashboard',
    },
    {
        path: 'login-dashboard',
        component: LoginDashboardComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Login Dashboard',
    },
    {
        path: 'mobile-topup-dashboard',
        component: MobileTopUpComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Mobile Topup Dashboard',
    },
    {
        path: 'overview-dashboard',
        component: OverviewDashboardComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Overview Dashboard',
    },
    {
        path: 'pay-anyone-dashboard',
        component: PayAnyoneDashboardComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Pay Anyone Dashboard',
    },
    {
        path: 'progressive-insights-dashboard',
        component: ProgressiveInsightsDashboardComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Progressive Insights Dashboard',
    },
    {
        path: 'utility-bill-dashboard',
        component: UtilityBillComponent,
        canActivate: [AuthGuardService],
        title: 'Fusion | Apis Dashboard',
    },
    {
        path: '',
        title: 'Dashboard',
        canActivate: [AuthGuardService, OnboardingGuard],
        loadChildren: () =>
            import('./epics/fusion/dashboard.module').then((m) => m.DashboardModule),
    },
    {
        path: 'workspaces',
        canActivate: [AuthGuardService, OnboardingGuard],
        loadChildren: () =>
            import('./epics/Workspace/workspaces-dashboard/workspaces.module').then(
                (m) => m.WorkspacesModule
            ),
    },
    {
        path: 'bug/public',
        // canActivate: [RouteGaurdGuard, PermissionGuard],
        title: 'Fusion | Bugs',
        loadChildren: () =>
            import('./epics/fusion/Pages/public-bug/bugs.module').then((m) => m.PublicBugsModule),
    },
    {
        path: 'workspace/workspace-setting',
        canActivate: [RouteGaurdGuard],
        title: 'Fusion | Workspace Setting',
        loadChildren: () =>
            import(
                './epics/Workspace/workspace-setting/workspace-setting.module'
            ).then((m) => m.WorkspaceSettingModule),
    },
    {
        path: 'projects',
        canActivate: [AuthGuardService, OnboardingGuard],
        loadChildren: () => import('./epics/Project/project-dashboard/project-dashboard.module')
            .then(x => x.ProjectDashboardModule)
    },
    {
        path: 'account-setting',
        // canActivate: [RouteGaurdGuard],
        title: 'Fusion | Account Setting',
        loadChildren: () =>
            import('./epics/Account/account-setting/account-setting.module').then(
                (m) => m.AccountSettingModule
            ),
    },
    {
        path: 'workspace/access-control',
        canActivate: [RouteGaurdGuard],
        title: 'Fusion | Bugs',
        loadChildren: () =>
            import(
                './epics/Workspace/access-control/access-control.module'
            ).then((m) => m.AccessControlModule),
    },
    {
        path: 'project/project-setting',
        canActivate: [RouteGaurdGuard],
        title: 'Fusion | Project Setting',
        loadChildren: () =>
            import('./epics/Project/project-setting/project-setting.module').then(
                (m) => m.ProjectSettingModule
            ),
    },
    {
        path: 'billings',
        // canActivate: [RouteGaurdGuard],
        title: 'Fusion | Billings',

        loadChildren: () =>
            import('./epics/Account/Billings/Billings.module').then(
                (m) => m.BillingsModule
            ),
    },
    {
        path: 'license-management',
        // canActivate: [RouteGaurdGuard],
        title: 'Fusion | License Management',

        loadChildren: () =>
            import('./epics/Account/License/license.module').then(
                (m) => m.LicenseModule
            ),
    },
    { path: '**', component: NotFoundComponent, canActivate: [OnboardingGuard] },  // Wildcard route for 404 page

];
@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
